// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Guide: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 47">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M43.169 10.672a6.425 6.425 0 0 0-4.562-1.887c-.98 0-1.958.225-2.828.645L35 9.81v-8.8C35 .454 34.55 0 33.994 0H1.009C.453 0 0 .454 0 1.01v6.655a1.008 1.008 0 0 0 2.016 0V2.02h5.35v4.927a1.01 1.01 0 0 0 1.007 1.007h18.254a1.01 1.01 0 0 0 1.01-1.007V2.02h5.344l.003 9.708-2.755 2.755a1.02 1.02 0 0 0 0 1.434 1.026 1.026 0 0 0 1.431-.004l3.095-3.1 6.269 6.273-11.546 11.548-6.268-6.271 1.961-1.96a1.022 1.022 0 0 0-.004-1.43 1.016 1.016 0 0 0-1.43.003l-2.669 2.672-.282.527-1.754 9.459c-.06.325.046.659.281.894.242.245.556.355.894.282l9.453-1.755.533-.278 2.791-2.791v14.1H2.016v-26.42a1.01 1.01 0 0 0-1.007-1.01c-.556 0-1.009.454-1.009 1.01v27.429c0 .56.453 1.013 1.009 1.013h32.985c.556 0 1.006-.453 1.006-1.013l-.003-17.125 8.172-8.168a6.411 6.411 0 0 0 1.888-4.563 6.418 6.418 0 0 0-1.888-4.566ZM9.383 5.937h16.234V2.02H9.383v3.917ZM21.29 32.555l1.132-6.12 4.986 4.984-6.118 1.136Zm21.442-15.691-.304.768-6.218-6.222.768-.301a4.46 4.46 0 0 1 4.761.997 4.394 4.394 0 0 1 1.301 3.132 4.34 4.34 0 0 1-.308 1.626Z"
                />
                <path
                    fill="currentColor"
                    d="M1.01 11.628a1.01 1.01 0 0 0-1.007 1.01v.447c0 .556.45 1.01 1.006 1.01s1.006-.454 1.006-1.01v-.447c0-.556-.45-1.01-1.006-1.01m18.492 5.025H8.375a1.008 1.008 0 1 0 0 2.016H19.5a1.009 1.009 0 0 0 0-2.016m-5.563 5.39H8.375c-.556 0-1.01.454-1.01 1.01s.454 1.006 1.01 1.006h5.563a1.009 1.009 0 0 0 0-2.016m0 5.392H8.375c-.556 0-1.01.454-1.01 1.01a1.01 1.01 0 0 0 1.01 1.006h5.563a1.009 1.009 0 0 0 0-2.016m0 5.39H8.375c-.556 0-1.01.454-1.01 1.007 0 .556.454 1.013 1.01 1.013h5.563c.556 0 1.006-.457 1.006-1.013 0-.553-.45-1.007-1.006-1.007m5.563 5.39H8.375a1.01 1.01 0 0 0 0 2.02H19.5a1.01 1.01 0 0 0 0-2.02m8.661-18.806.315-.318a1.013 1.013 0 0 0 0-1.43l-.715-.292-.712.295-.318.318a1.016 1.016 0 0 0 0 1.427 1.037 1.037 0 0 0 1.43 0"
                />
            </g>
        </svg>
    );
};

export default React.memo(Guide);
